/** Class toggled on `<html>` for coarse-touch mobile viewport shell CSS. */
export const MOBILE_SHELL_CLASS = "mf-mobile-shell";

/** Phones/tablets where tap is the primary pointer (not desktop). */
export function isCoarseTouchDevice() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(hover: none) and (pointer: coarse)").matches;
}

/**
 * Apply scroll/height policy to document.body.
 * Mobile coarse-touch: CSS shell on #root scrolls; skip inline body toggles.
 * Desktop: preserve existing height/overflow behavior.
 */
export function applyDocumentScrollPolicy({ isAdminLikeRoute }) {
  const root = document.documentElement;

  if (isCoarseTouchDevice()) {
    root.classList.add(MOBILE_SHELL_CLASS);
    document.body.style.height = "";
    document.body.style.overflow = "";
    return;
  }

  root.classList.remove(MOBILE_SHELL_CLASS);

  const bodyContentHeight = document.body.scrollHeight;
  const viewportHeight = window.innerHeight;

  if (isAdminLikeRoute) {
    document.body.style.height = "100dvh";
    document.body.style.overflow = "auto";
  } else if (bodyContentHeight > viewportHeight) {
    document.body.style.height = "auto";
    document.body.style.overflow = "auto";
  } else {
    document.body.style.height = "100dvh";
    document.body.style.overflow = "hidden";
  }
}

export function clearDocumentScrollPolicy() {
  document.documentElement.classList.remove(MOBILE_SHELL_CLASS);
  document.body.style.height = "";
  document.body.style.overflow = "";
}

/**
 * Prevent iOS from nudging #root scroll position when an input receives focus.
 * No-op on desktop. Returns a cleanup function.
 */
export function installMobileInputScrollGuard() {
  if (!isCoarseTouchDevice()) return () => {};

  const root = document.getElementById("root");
  if (!root) return () => {};

  const onFocusIn = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (
      !target.matches(
        'input, textarea, select, [contenteditable="true"]'
      )
    ) {
      return;
    }

    const lockedTop = root.scrollTop;
    requestAnimationFrame(() => {
      root.scrollTop = lockedTop;
    });
  };

  document.addEventListener("focusin", onFocusIn, true);
  return () => document.removeEventListener("focusin", onFocusIn, true);
}
